enum GAME_EVENTS {
  MINIGAME_STARTED = 'minigameStarted',
  MINIGAME_ENDED = 'minigameEnded',
  PLAYER_VISITED_NODE = 'playerVisitedNode',
  OPEN_INVENTORY = 'showInventory',
  COMPLETED_CURRENT_LEVEL = 'completedCurrentLevel',
  NPC_MODAL_CLOSED = 'npcModalClosed',
  BOOK_MODAL_CLOSED = 'bookModalClosed',
  LEVEL_EXIT_OPENED = 'levelExitOpened',
  CUTSCENE_STARTED = 'cutsceneStarted',
  CUTSCENE_FINISHED = 'cutsceneFinished',
  PLAYER_REQUESTED_NEXT_CUTSCENE_SLIDE = 'playerRequestedNextCutsceneSlide',
  NEXT_CUTSCENE_SLIDE_PLAYED = 'nextCutsceneSlidePlayed',
  VALID_WORD = 'validWord',
  SET_ACTIVE = 'setActive',
  PLAY_AI_WORD = 'playAIWord',
  SWITCH_TURN = 'switchTurn',
  PLAYER_TURN = 'playerTurn',
  AI_TURN = 'aiTurn',
  WORD_WAS_PLAYED = 'wordWasPlayed',
  DUELIST_WAS_DEFEATED = 'duelistWasDefeated',
  WORD_VERIFICATION_FINISHED = 'wordVerificationFinished',
  AI_PLAYED_WRONG_WORD = 'aiPlayedWrongWord',
  PLAYER_PLAYED_WRONG_WORD = 'playerPlayedWrongWord',
  RIPOSTE_STARTED = 'riposteStarted',
  DUELIST_ATTEMPTED_RIPOSTE = 'playerAttemptedRiposte',
  DUELIST_PERFORMED_RIPOSTE = 'playerPerformedRiposte',
  PLAYER_QUIT_DUEL = 'playerQuitDuel',
  TILEMAP_LEVEL_INITIALIZED = 'tilemapLevelInitialized',
  LEVEL_MAP_QUIT = 'levelMapQuit',
  PLAYER_REQUESTED_CUTSCENE_SKIP = 'playerRequestCutsceneSkip',
  PLAYER_REQUESTED_GUIDANCE_CUTSCENE = 'playerRequestedGuidanceCutscene',
  MASTERED_NEW_MINIGAME = 'masteredNewMinigame',
  PLAYER_REQUESTED_OPEN_DAILIES_PANEL = 'playerRequestedOpenDailiesPanel',
  DAILY_PANEL_OPENED = 'dailyPanelOpened',
  DAILY_PANEL_CLOSED = 'dailyPanelClosed',
  PLAYER_WON_DUEL = 'playerWonDuel',
  REWARD_EARNED = 'rewardEarned',
  PLAYER_CLAIMED_REWARD = 'playerClaimedReward',
  COIN_VALUE_CHANGED = 'coinValueChanged',
  PLAYER_REQUESTED_QUIT_MAIN_LEVEL = 'playerRequestedQuitMainLevel',
  PLAYER_CONFIRMED_QUIT_MAIN_LEVEL = 'playerConfirmedQuitMainLevel',
  COMPLETED_ASSESSMENT = 'completedAssessment',
  DUEL_STARTED = 'duelStarted',
  DUEL_ENDED = 'duelEnded',
  ENTERED_NEW_BIOME = 'enteredNewBiome',
  PLAYER_UPDATED_POST_ASSESSMENT = 'playerUpdatedPostAssessment',
  FINISHED_NPC_ASSET_PRELOAD = 'finishedNpcAssetPreload',
  FINISHED_DISPLAYING_DAILY_REWARD = 'finishedDisplayingDailyReward',
  FINISHED_FEEDBACK_FOR_ALL_DAILY_REWARDS = 'finishedFeedbackForAllDailyRewards',
  PLAYER_VIEWED_LEVEL_LESSON = 'playerViewedLevelLesson',
  PLAYER_ENDED_LEVEL_LESSON = 'playerEndedLevelLesson',
  PLAYER_REQUESTED_COMPLETE_ALL_NODES = 'playerRequestedCompleteAllNodes',
  PLAYER_REQUESTED_NPC_GUIDANCE = 'playerRequestedNpcGuidance',
  FINISHED_NODE_COMPLETE_FEEDBACK = 'finishedNodeCompleteFeedback',
  PLAYER_PURCHASED_COSMETIC = 'playerPurchasedCosmetic',
  COSMETIC_SHOP_OPENED = 'cosmeticShopOpened',
  COSMETIC_SHOP_CLOSED = 'cosmeticShopClosed',
  PLAYER_EQUIPPED_COSMETIC = 'playerEquippedCosmetic',
  PLAYER_UNEQUIPPED_COSMETIC = 'playerUnequippedCosmetic',
  INVENTORY_OPENED = 'inventoryOpened',
  INVENTORY_CLOSED = 'inventoryClosed',
  CHARACTER_CREATION_COMPLETED = 'characterCreationCompleted',
  PLAYER_PREVIEWED_COSMETIC = 'playerPreviewedCosmetic',
  PLAYER_TEXTURES_FINISHED_REFRESH = 'playerTexturesFinishedRefresh',
  PLAYER_VIEWED_HUD_WALKTHROUGH = 'playerViewedHudWalkthrough',
  PLAYER_REQUESTED_HUD_WALKTHROUGH = 'playerRequestedHudWalkthrough',
  MENTOR_INTRODUCTION_PANEL_CLOSED = 'mentorIntroductionPanelClosed',
  BUY_ALL_ITEMS = 'buyAllItems',
  MASTERIES_PANEL_OPENED = 'masteriesPanelOpened',
  MINIGAME_PROGRESS_UPDATED = 'minigameProgressUpdated',
  MINIGAME_CORRECT_ANSWER = 'minigameCorrectAnswer',
  MINIGAME_INCORRECT_ANSWER = 'minigameIncorrectAnswer',
  NODE_COMPLETED = 'nodeCompleted',
  MINIGAME_COMPLETED_SUCCESSFULLY = 'minigameCompletedSuccessfully',
  ASSESSMENT_WALKTHROUGH_COMPLETED = 'assessmentWalkthroughCompleted',
  ASSESSMENT_CONTROL_SCHEME_CHANGED = 'assessmentControlSchemeChanged',
  PLAYER_VIEWED_DUEL_WALKTHROUGH = 'playerViewedDuelWalkthrough',
  MUSIC_TOGGLED = 'musicToggled',
  STUDENT_LEVEL_UP = 'studentLevelUp',
  GENERAL_GAME_STATE_UPDATED_AFTER_LEVEL_COMPLETE = 'generalGameStateUpdatedAfterLevelComplete',
  USER_LOADED = 'userLoaded',
  USER_LOGOUT = 'userLogout',
  START_GAME = 'startGame',
  MINIGAME_CARD_STARTED_DRAGGING = 'minigameCardStartedDragging',
  MINIGAME_CARD_DROPPED = 'minigameCardDropped',
  SETTINGS_PANEL_OPENED = 'settingsPanelOpened',
  SETTINGS_PANEL_CLOSED = 'settingsPanelClosed',
  INPUT_METHOD_CHANGED = 'inputMethodChanged',
  SFX_ENABLED_TOGGLED = 'sfxEnabledToggled',
  PLAYER_REQUESTED_ACCOUNT_UPGRADE = 'playerRequestedAccountUpgrade',
  STUDENT_GAME_KEYBOARD_INPUT = 'studentGameKeyboardInput',
  ACTIVE_SCENE_CHANGED = 'activeSceneChanged',
  NEW_DUEL_WORD_STARTED = 'newDuelWordStarted',
  PLAYER_REQUESTED_DUEL_WALKTHROUGH = 'playerRequestedDuelWalkthrough',
  WORD_DEFINITION_BUTTON_CLICKED = 'wordDefinitionButtonClicked',
  WORD_EXAMPLE_BUTTON_CLICKED = 'wordExampleButtonClicked',
  WALKTHROUGH_COMPLETED = 'walkthroughCompleted',
  MINIGAME_CHECK_ANSWER = 'minigameCheckAnswer',
  SHOP_TAB_SELECTED = 'shopTabSelected',
  STUDENT_GAME_ROUND_STARTED = 'studentGameRoundStarted',
  PLAYER_CUSTOMIZATION_ASSETS_LOADED = 'playerCustomizationAssetsLoaded',
}

export default GAME_EVENTS;
